import { StratusStatsColumnValuesModel } from "./StratusStatsColumnValuesModel";

export class StratusStatsCardTeamTemplateModel {
    displayValue: string;
    percentageValue: number;
    highlightColor: string;
    name: string;
    columnValues: StratusStatsColumnValuesModel[];
    id: string;
    metricId: string;
    group: string;

    constructor(displayValue, percentageValue, highlightColor, name, columnValues: StratusStatsColumnValuesModel[], id, metricId, group) {
        this.displayValue = displayValue;
        this.percentageValue = percentageValue;
        this.highlightColor = highlightColor;
        this.name = name;
        this.columnValues = columnValues;
        this.id = id;
        this.metricId = metricId;
        this.group = group;
    }
}